export default __webpack_public_path__ + "static/media/GT-Walsheim-Bold.e9a3833e.woff";